import { ChangePassword } from 'components/templates';
import React, { useEffect } from 'react';
import { useLoginRefresh } from 'utils/hooks';

import { LoginViewBox } from './styles';

export const ChangePasswordView = () => {
  const { refresh, toggle } = useLoginRefresh();

  useEffect(() => {
    if (refresh) {
      toggle();
      window.location.reload();
    }
  }, [refresh]);
  return (
    <LoginViewBox>
      <ChangePassword />
    </LoginViewBox>
  );
};
